/*
 * tour-add-to-cart.js — add a tour product (e.g. a VIP package) to the cart
 * with the event stamped on as a line-item property, so the order shows
 * exactly which show it's for. Uses Shopify's AJAX Cart API and Dawn's cart
 * notification/drawer for feedback; falls back to the product page / cart on
 * error.
 */
if (!customElements.get('tour-add-to-cart')) {
  customElements.define(
    'tour-add-to-cart',
    class TourAddToCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (this.button) {
          this.onClick = this.onClick.bind(this);
          this.button.addEventListener('click', this.onClick);
        }
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      onClick() {
        const variantId = this.dataset.variantId;
        const productUrl = this.dataset.productUrl;

        // No purchasable variant — just send them to the product page.
        if (!variantId) {
          if (productUrl) window.location = productUrl;
          return;
        }

        const cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const body = { id: Number(variantId), quantity: 1 };
        if (this.dataset.event) {
          body.properties = { Event: this.dataset.event };
        }
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement?.(this.button);
        }

        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('is-loading');

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              // e.g. sold out / unavailable — fall back to the product page.
              if (productUrl) window.location = productUrl;
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(data);
            } else {
              window.location = cartUrl;
            }
          })
          .catch(() => {
            window.location = productUrl || cartUrl;
          })
          .finally(() => {
            this.button.removeAttribute('aria-disabled');
            this.button.classList.remove('is-loading');
          });
      }
    }
  );
}
